
class modalBlankCancelCtrl {
    constructor(
        $scope, $uibModalInstance, logger,
        invoiceOpenService,
    ) {
        const userInfo = JSON.parse(localStorage.getItem('user_info'))
        $scope.modaldata = {
            invType: '2',
            InfoNumber: '',
            InfoTypeCode: '',
            invStock: 0,
            ukey: {
                ukeyList: userInfo.sysUkeyList,
                ukeyId: userInfo.sysUkeyList[0].ukeyId,
            },
            inv_type: [
                {
                    enumName: '专用发票',
                    enumCode: '0',
                },
                {
                    enumName: '普通发票',
                    enumCode: '2',
                },
                {
                    enumName: '卷式发票',
                    enumCode: '41',
                },
                {
                    enumName: '机动车发票',
                    enumCode: '12',
                },
            ],
        }

        $scope.getInvStock = function getInvStock() {
            $scope.modaldata.ukey.ukeyList.forEach((ukey) => {
                if (ukey.ukeyId === $scope.modaldata.ukey.ukeyId) {
                    $scope.modaldata.ukeyCode = ukey.ukeyCode
                    $scope.modaldata.diskCode = ukey.diskCode
                    $scope.modaldata.ukey.manageType = ukey.manageType
                }
            })
            invoiceOpenService.getStockByUkey(
                $scope.modaldata.ukey.ukeyList,
                $scope.modaldata.ukey.ukeyId,
                $scope.modaldata.invType,
                true,
            ).then((obj) => {
                $scope.modaldata.invoiceCode = obj.invoiceCode
                $scope.modaldata.invoiceNumber = obj.invoiceNumber
                $scope.modaldata.invStock = obj.sum
            }, () => {
                $scope.modaldata.invoiceCode = ''
                $scope.modaldata.invoiceNumber = ''
                $scope.modaldata.invStock = 0
                logger.logError('获取库存信息失败')
            })
        }
        $scope.getInvStock()
        // 关闭
        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel')
        }

        const checkBlanksReq = function () {
            const { blanksReq } = $scope.modaldata
            if (!$scope.modaldata.blanksReq) {
                return false
            }
            const patrn = /^[0-9]*$/
            if (!patrn.test(blanksReq)) {
                return false
            }
            if (blanksReq < 1 || blanksReq > $scope.modaldata.invStock || blanksReq > 10) {
                return false
            }
            return true
        }


        // 确定
        $scope.ok = function (item) {
            if (checkBlanksReq()) {
                $uibModalInstance.close($scope.modaldata)
            } else {
                $scope.modaldata.blanksReq = ''
                logger.logError('请输入不大于发票份数且不大于10的非零正数')
            }
            // 返回数据
        }
    }
}

modalBlankCancelCtrl.$inject = ['$scope', '$uibModalInstance', 'logger', 'invoiceOpenService']
export default modalBlankCancelCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/billManage/cancelInvoice/modalBlankCancelCtrl.js